import {Component, ElementRef, HostListener, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs/internal/Subscription';
import {ActivatedRoute, ActivatedRouteSnapshot, Router} from "@angular/router";
import {AuthService} from "../../../services/auth.service";
import {RegistryService} from "../../../services/domain/registry.service";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {AnagraficaDto} from "../../../models/anagrafica.models";

@Component({
  selector: 'app-layout-master',
  templateUrl: './layout-master.component.html',
  styleUrls: ['./layout-master.component.css'],
  providers: [RegistryService]
})
export class LayoutMasterComponent {

  /* UI */

  public menuItems: SidebarMenuItem[] = [
    {title: 'Dashboard  ', icon: 'assets/img/material-dashboard', path: 'dashboard'},
    {title: 'Anagrafica ', icon: 'assets/img/awesome-user-circle', path: 'registry'},
    {title: 'Lavoro     ', icon: 'assets/img/ionic-md-briefcase', path: 'work'},
    {title: 'Istruzione ', icon: 'assets/img/awesome-graduation-cap', path: 'study'},
    {title: 'Preferenze ', icon: 'assets/img/material-stars', path: 'preferences'},
    {title: 'Annunci', icon: 'assets/img/Icon ionic-md-megaphone', path: 'annunci'},
    {title: 'Documenti ', icon: 'assets/img/Raggruppa91', path: 'document'},
  ];

  public endMenuItems : SidebarMenuItem[] = [
    {title: 'Impostazioni', icon: 'assets/img/ionic-ios-settings', path: 'settings'}
  ]

  public nomeUtente : string = '';
  public profileImageUrl : SafeResourceUrl | null = null;
  public baseImagePath : string = "";
  public registryDto : AnagraficaDto = new AnagraficaDto();
  public profileSex : string = "";
  /* CORE */

  constructor(
    private router: Router,
    private authService: AuthService,
    private route: ActivatedRoute,
    private registryService : RegistryService
  ) {
  }


  private insideClick = false;
  public searchBarActive: boolean = false;
  public scrHeight : number = 0;
  public scrWidth : number = 0;
  public isMobile : boolean = false;

  @HostListener('document:click', ['$event'])onDocumentClick(event: MouseEvent) {
    if (!this.insideClick && this.isMobile)
    {
      this.searchBarActive = false;
    }
    this.insideClick = false;
    this._setupActiveItem();
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event : any) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    this.isMobileControl();
  }

  ngOnInit() {
    this._handleQueryParams();
    this._setupActiveItem();
    if(AuthService.LoggedUser != null)
      this.nomeUtente = AuthService.LoggedUser.name ?? "";

    this.authService.getUserPhoto().then((value) => {
      this.profileImageUrl = value;
    });

    this.registryService.getRegistryDetail().subscribe(response => {
      this.registryDto = response.Item || new AnagraficaDto();
      this.profileSex = this.registryDto.Sesso;
    });

    this.authService.changeUserPhoto$.subscribe(response => {
      this.authService.getUserPhoto().then((value) => {
        this.profileImageUrl = value;
      });
    });

    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    this.baseImagePath = this.authService.baseImagePath;
    this.isMobileControl();
  }

  ngOnDestroy(): void {
  }

  /* PUBLIC */

  public selectMenuItemAt(index : number, isTopMenu : boolean, isHtmlClick : boolean) {

    if(isTopMenu){
      for (let i = 0; i< this.menuItems.length; i++){
        if(this.menuItems[i].isActive)
          this.menuItems[i].isActive=false;
      }

      if(isHtmlClick){
        for (let i = 0; i< this.endMenuItems.length; i++){
          if(this.endMenuItems[i].isActive)
            this.endMenuItems[i].isActive=false;
        }
      }

      for (let i = 0; i < this.menuItems.length; i++) {
        this.menuItems[i].isActive = i === index;
      }
      this.menuItems = [...this.menuItems];
    }
    else{
      for (let i = 0; i< this.endMenuItems.length; i++){
        if(this.endMenuItems[i].isActive)
          this.endMenuItems[i].isActive=false;
      }

      if(isHtmlClick){
        for (let i = 0; i< this.menuItems.length; i++){
          if(this.menuItems[i].isActive)
            this.menuItems[i].isActive=false;
        }
      }
      for (let i = 0; i < this.endMenuItems.length; i++) {
        this.endMenuItems[i].isActive = i === index;
      }
      this.endMenuItems = [...this.endMenuItems];
    }

  }

  public clickInternoSidebar(){
    this.insideClick = true;
  }

  public openMobileSidebar(){
    this.insideClick = true;
    this.searchBarActive = true;
  }

  public selectSettings(){
    this.router.navigate(['/settings']).catch(console.log);
  }

  public onClickLogout() {
    this.authService.signOut();
    this.router.navigate(['/signin']).catch(console.log);
  }

  /* PRIVATE */

  private _handleQueryParams() {
    const queryParams = this.route.snapshot.queryParams;

    const pathParam = queryParams['path'] as string;

    if (pathParam) {
      const newParams = {...queryParams};
      delete newParams['path'];

      this.router.navigate([pathParam], {queryParams: newParams}).catch(console.log);
    }
  }

  private _setupActiveItem() {

    let urlNoPrefix = this.router.url.replace('/', '');

    if (urlNoPrefix.includes('/')) {
      urlNoPrefix = urlNoPrefix.split('/')[0];
    }
    this.selectMenuItemAt(this.endMenuItems.findIndex(x => x.path == urlNoPrefix) || 0, false, false);

    this.selectMenuItemAt(this.menuItems.findIndex(x => x.path == urlNoPrefix) || 0, true, false);
  }

  private isMobileControl(){
    if(this.scrWidth < 900){
      this.isMobile = true;
    }else{
      this.isMobile = false;
    }
  }
}

export interface SidebarMenuItem {
  title: string,
  icon: string,
  path: string,
  isActive?: boolean,
}
